export default __webpack_public_path__ + "static/genesis_heroine-5ac315d143deb48eb222835f55bc7480.png";